var ssg = ssg || {};
ssg.util = {
    uuid : function(){
        return ((new Date()).valueOf().toString()) + (Math.floor((Math.random()*1000000)+1).toString());
    },
    wait: function(timeout){
        var deferred = $.Deferred();
        setTimeout(deferred.resolve, timeout);
        return deferred.promise();
    },
    scrollToTop: function (nTime) {
        $('html, body').animate({
            scrollTop: 0
        }, nTime);
    },
    scrollToBottom: function (nTime) {
        $('html, body').animate({
            scrollTop: $(document).height()
        }, nTime);
    },
    isAppliedPlugin: function (welTarget, sPluginName) {
        //sPluginName = >"plugin_flicking","plugin_scroller"
        return !$.data(welTarget.get(0), sPluginName);
    },
    hideAddressBar: function () {
        var hide = function () {
            if (!window.location.hash) {
                if (document.height < window.outerHeight) {
                    document.body.style.height = (window.outerHeight + 50) + 'px';
                }

                setTimeout(function () {
                    window.scrollTo(0, 100);
                }, 50);
            }
        };
        window.addEventListener("load", function () {
            if (!window.pageYOffset) {
                hide();
            }
        });
        window.addEventListener("orientationchange", hide);
    }
};